<template>
  <div>featured listing</div>
</template>

<script>
export default {};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/FeaturedListing.vue